export default __webpack_public_path__ + "static/media/Kenji.908709eb.png";